import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let AppointmentDeleteComponent = {
    selector: "vcAppointmentDelete",
    templateUrl:
        "/angular/components/planner/modals/appointment-delete.component.html",
    bindings: {
        permission: "=?",
    },
    controller: class GeneralInfoController {
        // * bindings for typescript compiler *
        public permission?: boolean;
        // ************************************

        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide();
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("planner")
    .component(AppointmentDeleteComponent.selector, AppointmentDeleteComponent);
